var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"one-click-cover",class:{hidden: !_vm.visible},on:{"click":_vm.click}})}
var staticRenderFns = []

export { render, staticRenderFns }